var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 7.17056L8.00016 3.57056L4.00017 7.17056V13.2407C4.00017 13.4861 4.19915 13.6851 4.44461 13.6851H5.48165V12.0374C5.48165 10.9821 6.34552 10.1295 7.40757 10.1295H8.59275C9.65481 10.1295 10.5187 10.9821 10.5187 12.0374V13.6851H11.5557C11.8012 13.6851 12.0002 13.4861 12.0002 13.2407V7.17056ZM13.4816 13.2407C13.4816 14.3043 12.6194 15.1666 11.5557 15.1666H9.77794C9.36884 15.1666 9.0372 14.8349 9.0372 14.4258V12.0374C9.0372 11.8042 8.84037 11.611 8.59275 11.611H7.40757C7.15995 11.611 6.96312 11.8042 6.96312 12.0374V14.4258C6.96312 14.8349 6.63149 15.1666 6.22238 15.1666H4.44461C3.38095 15.1666 2.51868 14.3043 2.51868 13.2407V8.49998C2.21525 8.72807 1.78242 8.69038 1.52365 8.40286C1.24998 8.09877 1.27463 7.63041 1.57871 7.35674L7.50463 2.0234C7.78634 1.76987 8.21398 1.76987 8.49569 2.0234L14.4216 7.35674C14.7257 7.63041 14.7503 8.09877 14.4767 8.40286C14.2179 8.69038 13.7851 8.72807 13.4816 8.49997V13.2407Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhome);
export default __webpack_public_path__ + "static/media/phome.11980e0d4290ce3dbafdd39d83cf65fb.svg";
export { ForwardRef as ReactComponent };